import { Component, OnInit } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
@Component({
  selector: 'app-hardwiring-kit-bottom-sheet',
  templateUrl: './hardwiring-kit-bottom-sheet.component.html',
  styleUrls: ['./hardwiring-kit-bottom-sheet.component.scss']
})
export class HardwiringKitBottomSheetComponent implements OnInit {

  constructor(private bottomSheetRef: MatBottomSheetRef<HardwiringKitBottomSheetComponent>) { }

  ngOnInit() {
  }
  close(): void {
    this.bottomSheetRef.dismiss();
  }
  
}
